import { render, staticRenderFns } from "./AttachUploadZJ.vue?vue&type=template&id=97708de2&scoped=true"
import script from "./AttachUploadZJ.vue?vue&type=script&lang=js"
export * from "./AttachUploadZJ.vue?vue&type=script&lang=js"
import style0 from "./AttachUploadZJ.vue?vue&type=style&index=0&id=97708de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97708de2",
  null
  
)

export default component.exports